<!--
 * @Author: lan.h
 * @Date: 2022-02-14 10:08:58
 * @LastEditors: lan.h
 * @LastEditTime: 2022-03-28 11:12:09
 * @Description: 快讯live
-->
<template>
  <div class="knowledge" v-if="newsTopicList.length > 0">
    <div class="mode-title">
      <span class="title-p">快讯Live</span>
      <div class="comp-src-name">快讯数据由 <img :src="$store.state.static_img_url+'pic/logo.png'" alt="动脉橙" @click="haddleApplyTry2(32)"> 提供支持</div>
    </div>
    <ul class="flash_list">
      <li v-for="item,index in newsTopicList" :key="index">
        <p class="header">
          <span class="header-yuan"></span>
          <span>{{item.newsTopicType[0] | deal('news_topic_type', 'name', '')}}</span>
          <span class="header-time">{{item.publishTime | time_standard}}</span>
        </p>
        <p href="javascript:;" class="flash_btn" >{{item.title}}</p>
        <div class="info">
          <div class="summary" v-html="item.summary"></div>
          <div class="company">
            <p>
              <i class="iconfont" v-if="item.entityList.length > 0">&#xe660;</i>
              <span v-for="a in item.entityList" :key="a.id" @click="toEntity(a)">{{a.shortName}}</span>
            </p>
            <div class="time">
              <Poptip trigger="hover" placement="bottom-end" padding="0" width="248" @on-popper-show="haddleShare(item.uid)" @on-popper-hide="haddleShareHide">
                <i class="iconfont w">&#xe641;</i>
                <div slot="content" class="share_cnt clear">
                  <div class="share_img"></div>
                  <p>打开微信“扫一扫”<br />点击右上角分享按钮</p>
                </div>
              </Poptip>
            </div>
          </div>
        </div>
      </li>
      <div class="flash-more" @click="more">
        <a>查看更多</a>
      </div>
    </ul>
</div>
</template>
<script>
import { newstopiclist } from '../../service'

export default {
  inject: ['haddleApplyTry2'],
  data() {
    return {
      newsTopicList: []
    }
  },
  created() {
    this.getList()
  },
  methods: {
    topicInfo() {
      $('.flash_list').on('click', '.flash_btn', function () {
				var _that = $(this).parents('li');
				_that.children('.info').slideToggle(200);
				_that.toggleClass('on');
        _czc.push(['_trackEvent', '首页(新)', '右侧快讯LIVE栏目(标题)', '点击量'])
			});
    },
    async getList() {
      let res = await newstopiclist( {
        content_type: 4,
        page: 1,
        size: 5
      }, (error) => {
        this.$Message.error('请求错误！')
      })
      if (res.code == 0) {
        this.$set(this.$data, 'newsTopicList', res.data)
        this.$nextTick(() =>{
          this.topicInfo()
        })
        this.$emit("getTopic")
      } else {
        this.$Message.error(res.msg)
      }
    },
    toEntity(a) {
      if(a.type == 0){
        const href = this.$store.state.index_path + '/companyDetail/' + a.uid
        window.open(href, '_blank')
      }else if(a.type == 1){
        const href = this.$store.state.index_path + '/orgDetail/' + a.uid
        window.open(href, '_blank')
      }
    },
    more() {
      const href = this.$store.state.index_path + '/newsList'
      window.open(href, '_blank')
      _czc.push(['_trackEvent', '首页(新)', '右侧快讯LIVE栏目(查看更多)', '点击量'])
    },
    haddleShare(uid) {
      let share_link = this.$store.state.index2_path+ '/News/newsDetail?uid=' + uid
      jQuery($('.share_img')).qrcode({
        width: 80,
        height: 80,
        correctLevel: 0,
        text: share_link
      })
    },
    haddleShareHide() {
      $('.share_img').html('')
    },
  }
}
</script>

<style lang="stylus" scoped>
.flash_list
  border-left 2px solid #F3F3F3
  margin-top 20px
  padding-left 15px
  li 
    padding 6px 0 10px
    cursor pointer
    .header 
      padding 0
      line-height 1
      position relative
      font-size 12px
      font-weight 500
      span 
        color #FA5A00
        display inline-table
        position relative
      span:nth-child(1)
        width 12px
        height 12px
        background #FFBA80
        border-radius 50%
        position absolute
        left -22px
        top 0
      .header-time
        float right
        color #666666
    .flash_btn
      font-size 14px
      font-weight 500
      color #333333
      line-height 22px
      margin-top 10px
      transition all .5s
      cursor pointer
      &:hover 
        color #FA5A00
    .info 
      margin-top 10px
      display none
      font-size 12px
      .summary 
        color #666
        line-height 24px
      .time 
        font-size 12px
        color #999
        width 18px
        color #999999
        position relative
        .w
          width 18px
          height 18px
          background #F3F3F3
          border-radius 2px
          padding 3px
          color #CCCCCC
          font-size 12px
          transition all .5s
        .w:hover,.w.active
          color #fff
          background #63BF61
        >>> .ivu-poptip
          .ivu-poptip-rel
            cursor pointer
          .ivu-poptip-popper
            transform translate(13px, 0)
            .ivu-poptip-inner
              border-radius 0
              .share_cnt
                padding 10px 20px 10px 10px
                .share_img
                  width 80px
                  height 80px
                  float left
                  background #f0f0f0
                p
                  line-height 20px
                  color #666
                  float right
                  margin-top 20px
                  font-size 14px
      .company 
        margin-top 10px
        font-size 0
        position relative
        line-height 14px
        display flex 
        justify-content space-between
        p:nth-child(1)
          width 210px
          flex 1
          i 
            color #FA5A00
            margin-right 6px
            font-size 12px
          span 
            margin-right 12px
            font-size 12px
            color #FA5A00
            &:hover
              transition all 0.5s
              color #FF4800
          span:last-child 
            margin-right 0
    // &:hover
    //   transition all 0.5s
    //   .info 
    //     display block
.flash-more
  margin-top 10px
</style>
